<template>
  <div
    class="searchbox"
    :class="[{'open': active}]"
  >
    <input
      type="text"
      placeholder="Search Users"
      @blur="onBlur"
      ref="search"
      v-model="model"
    />
    <i
      class="fa fa-search search-icon"
      @click="onClick"
    />
    <i
      class="fa fa-times close-icon"
      v-if="active && model.length > 0"
      @click="clearBox"
    />
  </div>
</template>
<script>
export default {
  props: {
    value: String,
  },
  data() {
    return {
      active: false,
    };
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    clearBox() {
      this.model = '';
      this.active = false;
    },
    onBlur() {
      console.log(this.model);
      if (this.model.length <= 0) {
        this.active = false;
      }
    },
    onClick() {
      this.active = true;
      console.log(this.$refs.search);
      this.$nextTick(() => {
        this.$refs.search.focus();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
  .searchbox {
    position: relative;
    display: flex;
    justify-content: flex-end;

    input {
      width: 0;
      visibility: hidden;
      opacity: 0;
      padding: .25rem .5rem;
      transition: all .25s;
      border-radius: .25rem;
      border: 1px solid #e4e4e4;
    }

    .search-icon {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: all .25s;
      color: #626262;
      cursor: pointer;
    }

    .close-icon {
      position: absolute;
      top: 0;
      right: .6rem;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: all .25s;
      color: #626262;
      cursor: pointer;
    }

    &.open {
      input {
        width: 100%;
        visibility: visible;
        opacity: 1;
        padding-left: 2rem;
      }
      .search-icon {
        right: calc(100% - 1.6rem);
      }
    }
  }
</style>